import { useLanguage } from "@/lib/i18n";

export default function Marquee() {
  const { t } = useLanguage();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-[#E2DCD5] bg-sand/60 py-5 overflow-hidden"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center gap-10 shrink-0">
            <span className="font-serif italic text-lg sm:text-xl text-ink/80 whitespace-nowrap">
              {item}
            </span>
            <span className="w-1.5 h-1.5 rotate-45 bg-terracotta shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
